const Loader = (props: { fill: string }) => {
  const fill = props.fill || 'currentColor'

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='125'
      height='50'
      viewBox='0 0 125 50'
      fill='none'
    >
      <rect width='25' height='25' fill={fill} x={0} y={25}>
        <animate
          id='left'
          attributeName='width'
          begin='0s; right.end+0.25s'
          dur='0.5s'
          from='25'
          to='75'
          fill='freeze'
        />
        <animate
          id='right'
          attributeName='width'
          begin='left.end+0.25s'
          dur='0.5s'
          from='75'
          to='25'
          fill='freeze'
        />
      </rect>
      <rect width='25' height='25' fill={fill} x={25} y={0}>
        {/* <set attributeName='x' to='75' /> */}
        <animate
          id='left'
          attributeName='x'
          begin='0s; right.end+0.25s'
          dur='0.5s'
          from='25'
          to='75'
          fill='freeze'
        />
        <animate
          id='right'
          attributeName='x'
          begin='left.end+0.25s'
          dur='0.5s'
          from='75'
          to='25'
          fill='freeze'
        />
      </rect>
      <rect width='75' height='25' fill={fill} x={50} y={25}>
        <animate
          id='left'
          attributeName='width'
          begin='0s; right.end+0.25s'
          dur='0.5s'
          from='75'
          to='25'
          fill='freeze'
        />
        <animate
          attributeName='x'
          begin='0s; right.end+0.25s'
          dur='0.5s'
          from='50'
          to='100'
          fill='freeze'
        />
        <animate
          id='right'
          attributeName='width'
          begin='left.end+0.25s'
          dur='0.5s'
          from='25'
          to='75'
          fill='freeze'
        />
        <animate
          attributeName='x'
          begin='left.end+0.25s'
          dur='0.5s'
          from='100'
          to='50'
          fill='freeze'
        />
      </rect>
    </svg>
  )
}

export default Loader
